export default function IntroSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4 whitespace-nowrap">
              What Is It?
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-tight">
              What Is a Sugargoo Spreadsheet?
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              A <strong>Sugargoo spreadsheet</strong> is a carefully curated product resource system that helps international shoppers discover trending items, compare products across different sellers, and organize their purchases from Chinese marketplaces. These spreadsheets are built by experienced shoppers who have tested products and verified sellers, saving you countless hours of searching.
            </p>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              Instead of manually browsing through thousands of listings, a Sugargoo spreadsheet gives you direct access to verified product links, quality assessments, pricing insights, and shipping estimates — all organized in one convenient document.
            </p>

            <div className="mt-6 overflow-x-auto">
              <table className="w-full text-sm border-collapse">
                <thead>
                  <tr className="border-b border-background-300">
                    <th className="text-left py-3 pr-4 font-semibold text-foreground-800 whitespace-nowrap">Feature</th>
                    <th className="text-left py-3 pr-4 font-semibold text-foreground-500 whitespace-nowrap">Without Spreadsheet</th>
                    <th className="text-left py-3 font-semibold text-primary-600 whitespace-nowrap">With Sugargoo Spreadsheet</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-background-200">
                    <td className="py-3 pr-4 text-foreground-800 whitespace-nowrap">Finding Products</td>
                    <td className="py-3 pr-4 text-foreground-500">Slow, manual searching</td>
                    <td className="py-3 text-primary-700 font-medium">Organized curated lists</td>
                  </tr>
                  <tr className="border-b border-background-200">
                    <td className="py-3 pr-4 text-foreground-800 whitespace-nowrap">Product Discovery</td>
                    <td className="py-3 pr-4 text-foreground-500">Random browsing</td>
                    <td className="py-3 text-primary-700 font-medium">Curated selections</td>
                  </tr>
                  <tr className="border-b border-background-200">
                    <td className="py-3 pr-4 text-foreground-800 whitespace-nowrap">Shopping Process</td>
                    <td className="py-3 pr-4 text-foreground-500">Difficult and confusing</td>
                    <td className="py-3 text-primary-700 font-medium">Much easier and guided</td>
                  </tr>
                  <tr>
                    <td className="py-3 pr-4 text-foreground-800 whitespace-nowrap">Beginner Experience</td>
                    <td className="py-3 pr-4 text-foreground-500">Confusing and overwhelming</td>
                    <td className="py-3 text-primary-700 font-medium">Guided step-by-step</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="relative">
            <div className="w-full aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20bright%20workspace%20scene%20with%20an%20open%20laptop%20displaying%20organized%20fashion%20product%20grids%20next%20to%20fabric%20swatches%20and%20a%20notebook%2C%20warm%20natural%20daylight%20from%20a%20nearby%20window%2C%20cream%20and%20sand%20neutral%20palette%2C%20editorial%20photography%20with%20soft%20focus%20and%20organic%20composition%2C%20aesthetic%20flatlay%20with%20shopping%20notes%20and%20product%20cards&width=800&height=600&seq=what-is-v2&orientation=landscape"
                alt="Sugargoo spreadsheet product curation workspace with organized shopping lists"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}